import React, { useState, useEffect } from 'react';
import { MessageCircle, Menu, X } from 'lucide-react';
import { navLinks } from '../mock';
import PinarLogo from './PinarLogo';

const Brand = () => (
  <a href="#top" className="flex items-center gap-3">
    <span className="flex items-center justify-center h-12 w-12 shrink-0">
      <PinarLogo size={48} />
    </span>
    <div className="leading-tight">
      <div className="font-serif text-[16px] font-semibold tracking-[0.14em] text-[#1E3A5F]">
        PINAR ENGLISH
      </div>
      <div className="font-serif text-[10px] tracking-[0.32em] text-[#B08D3C] mt-0.5">
        A C A D E M Y
      </div>
    </div>
  </a>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-[#FAF6EC]/95 backdrop-blur-md border-b border-[#B08D3C]/20' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-3 flex items-center justify-between">
        <Brand />

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[13px] font-medium text-[#1E3A5F]/85 hover:text-[#9B2C3B] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/english-id/login"
            className="text-[13px] font-semibold text-[#1E3A5F] border border-[#1E3A5F]/30 hover:bg-[#1E3A5F] hover:text-[#FAF6EC] px-3.5 py-1.5 rounded-full transition-colors"
            data-testid="nav-english-id-link"
          >
            English ID
          </a>
        </nav>

        <a
          href="https://wa.me/59899200180"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-whatsapp-btn"
          className="hidden md:inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BD5A] text-white text-[13px] font-semibold px-5 py-2.5 rounded-full transition-colors shadow-sm"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp
        </a>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 text-[#1E3A5F]"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FAF6EC] border-t border-[#B08D3C]/20 px-6 py-4 space-y-3">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-sm font-medium text-[#1E3A5F]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/english-id/login"
            className="block text-sm font-semibold text-[#1E3A5F]"
            data-testid="nav-english-id-link-mobile"
          >
            English ID
          </a>
          <a
            href="https://wa.me/59899200180"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn-mobile"
            onClick={() => setOpen(false)}
            className="inline-flex items-center gap-2 bg-[#25D366] text-white text-sm font-semibold px-4 py-2 rounded-full"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
